export const ROUTES = {
  LOGIN: "/login",
  MAGIC_UPLOAD: "/magic-upload",
  CONTROL_PANEL: "/control-panel",
  SCREENING_TOOL_BASE_DEFINITION: "/screening-tool/:fundId?",
  SCREENING_TOOL: "/screening-tool",
  COMPANY_PROFILE_DEFINITION: "/company-profile/:companyId",
  COMPANY_PROFILE: "/company-profile",
  METRICS: "/metrics",
  MY_FUNDS: "/my-funds",
  STEWARDSHIP: "/stewardship",
  WORKSPACE_DEFINITION: "/workspace/:paramType?",
  WORKSPACE: "/workspace",
  ADD_FILE: "/add-file",
  ADD_FILE_DEFINITION: "/add-file/:fileType?",
  REPORTS_LIST: "/reports-list",
  // Company Engagements - company-level list of all engagements
  COMPANY_ENGAGEMENTS_DEFINITION: "/company-engagements/:companyId",
  COMPANY_ENGAGEMENTS: "/company-engagements",
  // Single Engagement - detail view for one engagement
  SINGLE_ENGAGEMENT_DEFINITION: "/engagement/:engagementId",
  SINGLE_ENGAGEMENT: "/engagement",
  // Legacy routes - kept for backward compatibility
  ENGAGEMENT_MODULE_DEFINITION: "/engagement-module/:companyId",
  ENGAGEMENT_MODULE: "/engagement-module",
  ENGAGEMENT_DETAILS_DEFINITION: "/engagement-details/:engagementId",
  ENGAGEMENT_DETAILS: "/engagement-details",
  COMPASS_AI: "/compass-ai",
  LINKAGE_DASHBOARD: "/linkage-dashboard",
  ASSESSMENT_VIEW_DEFINITION: "/assessment-view/:engagementId",
  ASSESSMENT_VIEW: "/assessment-view",
  ASSESSMENT_INSIGHTS: "/assessment-insights",
};
